import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { common } from './common'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loadingIndicator: false
  },
  getters: {},
  mutations: {
    getLoadingIndicator(state) {
      return state.loadingIndicator
    },
    setLoadingIndicator(state, bool) {
      state.loadingIndicator = bool
    }
  },
  actions: {},
  modules: {
    common
  }
})
